import { useConfigStore, waitForMaintenanceEnd } from '@gc-bridge/stores/config';
import { useCurrentUserStore } from '@gc-bridge/stores/currentUser';
import { isRemoteInMaintenanceMode, rewritePath } from '@gcportal/base';
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export const rewriteRequestsPath = async (config: InternalAxiosRequestConfig) => {
  const transformedUrl = rewritePath(config.url?.toString() ?? '');

  return {
    ...config,
    url: transformedUrl,
  };
};

axios.interceptors.request.use(
  function (config) {
    return rewriteRequestsPath(config);
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function registerMaintenanceModeInterceptor(
  axiosInstance: AxiosInstance,
  remoteName: string,
  openMaintenanceDialog: () => void,
  closeMaintenanceDialog: () => void
) {
  axiosInstance.interceptors.request.use(
    async (config) => {
      const userGroups = useCurrentUserStore.getState().user?.groups;
      const remote = useConfigStore
        .getState()
        .config?.remotes.find((remote) => remote.name === remoteName);

      if (remote && isRemoteInMaintenanceMode(remote, userGroups)) {
        openMaintenanceDialog();
        await waitForMaintenanceEnd(remoteName, userGroups);

        closeMaintenanceDialog();
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
}
